import React, {useContext} from "react";

import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { Navigation } from "swiper";
import 'swiper/swiper.scss';

import Solution from "./solution";
import NoSolutionsFound from './noSolutionsFound';
import NoSolutionsSelected from './noSolutionsSelected';

import {AppContext} from "../App";

export default function Solutions() {
    const { data } = useContext(AppContext);
    const {challenges, products, solutions} = data;

    const challengesSelected = challenges
        .filter(challenge => challenge.selected)
        .map(challenge => challenge.id);

    const productsSelected = products
        .filter(product => {
            const {challengesIDs} = product;

            if (product.selected) {
                return challengesIDs.some(challengeIndex => challengesSelected.includes(challengeIndex));
            } else {
                return false;
            }
        })
        .map(product => product.id);

    const renderSlides = solutions
        .filter(solution => {
            const {challengeIDs} = solution;

            return challengeIDs.some(challengeIndex => {
                return challengesSelected.includes(challengeIndex);
            })
        })
        .filter(solution => {
            const {productIDs} = solution;

            if (productsSelected.length < 1) {
                data.noSolutionsFound = true;
            } else {
                data.noSolutionsFound = false;
            }

            return productIDs.some(challengeIndex => {
                return productsSelected.includes(challengeIndex);
            })

        })
        .map((solution) => ( <SwiperSlide key={solution.id}> <Solution solution={solution} /> </SwiperSlide> ));

    const ShowEmptyContent = data.noSolutionsFound ?  <NoSolutionsFound /> : <NoSolutionsSelected />;

    const SolutionsCounter = <div className="solutionsCounter">{renderSlides.length} <br/>Solutions</div>

    const SolutionsContent = <Swiper navigation={true}  modules={[Navigation]} className="carousel" >
        {renderSlides}
    </Swiper>

    return (
        <>
            {SolutionsCounter}
            { renderSlides.length > 0 ? SolutionsContent : ShowEmptyContent }
        </>
    );
}
